/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { Dialog } from 'vant';

// import { parseQueryParams } from '@/utils/url';
import { RouterNameObj, VvflyPath, WxLoginType } from '@/typeAll';
import { getDelQKeyUrl, parseQueryParams } from '@/utils/url';
import { getUserInfo } from '@/api/user';
import store from '@/store';
import { wxLogin } from '@/utils/wxTools';
import QRCODE_FOR_GH from '@/assets/img/qrcode_for_gh.jpg';
import HomeView from '../views/HomeView.vue';

Vue.use(VueRouter);

// meta: { title: '售后服务'(标题), loginType: WxLoginType.base(空为不需要登录), subscribe: (是否必须关注公众号), mntLogin:f(是否需要 售后的登录)  },

// const VvflyPath = '/vvfly'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/ya50Wish',
        name: RouterNameObj.ya50Wish,
        component: () =>
            import(
                /* webpackChunkName: "ya50Wish" */ '@/views/ya50EarlyStageWish/ya50EarlyStageWish.vue'
            ),
        meta: { title: '终结打鼾+，掌上呼吸机强势来袭', loginType: WxLoginType.userinfo },
    },
    {
        path: '/ya50WishOrder',
        name: RouterNameObj.ya50WishOrder,
        component: () =>
            import(
                /* webpackChunkName: "ya50WishOrder" */ '@/views/ya50EarlyStageWish/confirmOrder.vue'
            ),
        meta: { title: '确认订单', loginType: WxLoginType.userinfo },
        // meta: { title: '确认订单' },
    },
    {
        path: '/ya50WishOrderList',
        name: RouterNameObj.ya50WishOrderList,
        component: () =>
            import(
                /* webpackChunkName: "ya50WishOrderList" */ '@/views/ya50EarlyStageWish/orderList.vue'
            ),
        meta: { title: '订单列表', loginType: WxLoginType.userinfo },
    },
    {
        path: '/ya50WishOrderDetails',
        name: RouterNameObj.ya50WishOrderDetails,
        component: () =>
            import(
                /* webpackChunkName: "ya50WishOrderDetails" */ '@/views/ya50EarlyStageWish/orderDetails.vue'
            ),
        meta: { title: '订单详情', loginType: WxLoginType.userinfo },
    },
    // 注意, 这个路径不能够修改 注意, 这个路径不能够修改 注意, 这个路径不能够修改, /maintenance 为云中飞公众号的页面
    {
        path: `/maintenance`,
        name: RouterNameObj.maintenance,
        component: () =>
            import(/* webpackChunkName: "maintenance" */ '@/views/maintenance/home.vue'),
        meta: {
            title: '售后服务',
            loginType: WxLoginType.base,
            subscribe: true,
            mntLogin: true,
        },
    },
    {
        path: `${VvflyPath}/maintenances/create`,
        name: RouterNameObj.maintenanceCreate,
        component: () =>
            import(/* webpackChunkName: "maintenanceCreate" */ '@/views/maintenance/create.vue'),
        meta: {
            title: '领取保修卡',
            loginType: WxLoginType.base,
            subscribe: true,
            mntLogin: true,
        },
    },
    {
        path: `${VvflyPath}/maintenances/cardDetails`,
        name: RouterNameObj.maintenanceCardDetails,
        component: () =>
            import(
                /* webpackChunkName: "maintenanceCardDetails" */ '@/views/maintenance/cardDetails.vue'
            ),
        meta: {
            title: '电子保修卡',
            loginType: WxLoginType.base,
            subscribe: true,
            mntLogin: true,
        },
    },
    {
        path: `${VvflyPath}/maintenances/login`,
        name: RouterNameObj.maintenanceLogin,
        component: () =>
            import(/* webpackChunkName: "maintenanceLogin" */ '@/views/maintenance/login.vue'),
        meta: { title: '登录', loginType: WxLoginType.base, subscribe: true },
    },
];

const router = new VueRouter({
    routes,
});

router.beforeEach(async (to, from, next) => {
    const { token, maintenanceToken } = store.state;

    console.log('to', to);

    const { meta } = to;
    const { title, loginType, subscribe, mntLogin } = meta || {};

    // 微信登录处理 s
    const { code } = parseQueryParams(location.href);
    if (loginType && !token && !code) {
        const useUrl = getDelQKeyUrl(location.href);
        wxLogin(useUrl || location.href, loginType);
        return;
    }
    // 微信登录处理 e

    try {
        // code 处理 s
        console.log('code 处理 s 1');
        const q = parseQueryParams(location.href);
        console.log(location.href, 'q11', q);

        if (q.code && !token) {
            const sendData = {
                code: q.code,
            };
            console.log('code 处理 s 2');

            const resData = await getUserInfo(sendData);
            console.log('尝试获取用户信息 resData', resData);
            store.commit('setAny', resData);
        }
        // code 处理 e
    } catch (e) {
        console.error('beforeEach 222', e);
        // 大概是code解析失败
        Dialog.confirm({
            title: '错误',
            message: '微信登录失败, 是否重新尝试',
        })
            .then(() => {
                const url = getDelQKeyUrl(location.href);
                location.href = url;
            })
            .catch(() => {
                console.log('next 1');
                // pass
            });
        console.log('next 1.1');
    }

    // 售后token处理 s
    // const mntLogin = to.meta.mntLogin;
    // const { token, maintenanceToken } = store.state;
    const useMaintenanceToken = store.state.maintenanceToken;
    if (mntLogin && !useMaintenanceToken) {
        console.log('-----售后token处理--------to', to);
        next(`${VvflyPath}/maintenances/login`);
        return;
    }
    // 售后token处理 e

    console.log('最后 next');

    next();
    // if (to.name !== RouterNameObj.maintenanceLogin) {
    //     next({ name: RouterNameObj.maintenanceLogin })
    //     return
    // }
    // next();
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
    const { meta } = to;
    const { title, loginType, subscribe } = meta || {};
    const { token, subscribeIng } = store.state;
    if (title) {
        document.title = title;
    }

    // 关注处理 s
    // 必须有了用户信息才能够做判断
    if (token && subscribe && !subscribeIng) {
        // 弹出公招号弹框
        Dialog.confirm({
            title: '提示',
            message: `<div>为了更好的服务您, 本功能需要关注"云中飞"公众号<div/><div>请长按下方图片关注<div/><img src="${QRCODE_FOR_GH}" style="width: 80%; margin: 0 auto; margin-top: 5px;" alt=""><div>关注后请刷新本页面</div>`,
        });
    }
    // 关注处理 e
});

export default router;
